module.exports = __webpack_public_path__ + "static/bamboo-fibre-d0a8c33ba78b1401172abd773eedf08a.jpg";